import { Button, Signage } from '@kcd/design-system';

import { useGoHome } from '~/hooks/url';

import { DataErrorImg } from '~/assets/img/common';

export default function ErrorPage({
  title = '일시적인 오류가 발생했습니다.',
  description,
  resetText = '캐시노트마켓 홈으로 이동',
  onResetClick,
}: {
  title?: string;
  description?: string;
  resetText?: string;
  onResetClick?: React.MouseEventHandler<HTMLButtonElement>;
}) {
  const goHome = useGoHome('replace');

  return (
    <Signage
      verticalCenter
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
      marginTop={0 as any}
      image={() => (
        <img src={DataErrorImg.src} className="size-64" alt="error guide" />
      )}
      title={title}
      description={
        <p className="text-hint typo-caption100-regular">
          {description || (
            <>
              서비스 이용에 불편을 드려 죄송합니다. <br /> 일시적인 장애이거나
              네트워크 문제일 수 있습니다.
              <br /> 잠시 후 다시 시도해주세요.
            </>
          )}
        </p>
      }
      action={
        <Button
          size="sm"
          className="-mt-16"
          variant="outline"
          onClick={onResetClick || goHome}
        >
          {resetText}
        </Button>
      }
    />
  );
}
